import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutesService } from '@shared/services/routes.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: [ './topbar.component.scss' ],
})
export class TopbarComponent implements OnInit {
  @Input() backUrl: string;
  @Input() mainTitle: string;
  @Input() secondTitle: string;
  /* if catchBackClick is true, backButton with emit backClick event instead of navigation */
  @Input() catchBackClick: boolean;
  @Output() backClick = new EventEmitter();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private routesService: RoutesService
  ) {
  }

  ngOnInit(): void {
  }

  goBack() {
    if (this.catchBackClick) {
      this.backClick.emit();
      return;
    }
    this.router.navigate([ this.backUrl ], { relativeTo: this.route }).then();
  }
}
